export default {
    deviceIdentity: {}
}